import { InteractionRequiredAuthError, SilentRequest } from '@azure/msal-browser';
import jwt_decode from 'jwt-decode';
import { loginRequest, msalInstance } from '~/auth-config';

export const isTokenExpired = (token) => {
  const decoded = jwt_decode<{ exp: number }>(token);
  const currentTime = Date.now() / 1000;
  return decoded.exp < currentTime;
};

export const getAccessToken = async () => {
  const userAccount = msalInstance.getActiveAccount();
  if (!userAccount) return;
  // If you register GraphQL Api as different application, pass in the registed scopes here
  const accessTokenRequest: SilentRequest = {
    account: userAccount,
    ...loginRequest,
  };
  try {
    const response = await msalInstance.acquireTokenSilent(accessTokenRequest);
    return response.accessToken;
  } catch (error) {
    console.log('Silent token acquisition fails. Acquiring token using popup. \n', error);
    if (error instanceof InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      return msalInstance.acquireTokenRedirect(accessTokenRequest);
    } else {
      console.log(error);
    }
  }
};
